import styled from '@emotion/styled';
import { COLORS } from '../../constants';
import { IPosition } from '../../types';

export const StyledColorPicker = styled.div<{ colorPickerPosition?: IPosition }>`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  align-items: center;
  flex-wrap: nowrap;
  min-width: 50px;
  bottom: ${({ colorPickerPosition }) => (colorPickerPosition?.y ? `${colorPickerPosition.y}px` : '0px')};
  left: ${({ colorPickerPosition }) => (colorPickerPosition?.x ? `${colorPickerPosition.x}px` : '0px')};
  padding: 9px 7px 9px 7px;
  height: 32px;
  z-index: 100;
  background: ${COLORS.white};

  box-sizing: border-box;
  box-shadow:
    0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);

  position: absolute !important;
`;
export const StyledColor = styled.div<{ color: string; isChosen: boolean }>`
  background: ${({ color }) => color};
  cursor: pointer;
  border: ${({ isChosen }) => (isChosen ? `2px solid ${COLORS.debianRed}` : 'none')};

  height: 14px;
  width: 15px;
  &:not(:last-child) {
    margin-right: 8px;
  }
  border-radius: 4px;
`;
